import React from 'react';

import { nanoid } from 'nanoid/non-secure';

export type StoreIDType = string;

const StoreIDContext = React.createContext<StoreIDType | null>(null);

/**
 * ID 를 제공하는 Store Provider.
 */
export const StoreIDProvider = ({ children }: { children: React.ReactNode }) => {
  const id = React.useMemo(() => nanoid(), []);
  return <StoreIDContext.Provider value={id}>{children}</StoreIDContext.Provider>;
};

/**
 * Store ID 사용.
 */
export const useStoreID = () => {
  const id = React.useContext(StoreIDContext);
  if (id == null) {
    throw new Error('"useStoreID" was NOT used in "StoreIDProvider" component.');
  }
  return id;
};
